import { Model } from 'miragejs';

// Mirage-only Model
// Helps simulate the ActiveStorage / Direct Upload endpoints.
// This model is server-side / payload only.
// It is not consumed by Ember Data.

export default Model.extend({
  toJSON() {
    const { id, key, filename, content_type, metadata, byte_size, checksum, created_at, signed_id, direct_upload } =
      this;

    return {
      id,
      key,
      filename,
      content_type,
      metadata,
      byte_size,
      checksum,
      created_at,
      signed_id,
      direct_upload,
    };
  },
});
